import styled, { css } from 'styled-components'

export const IntegrationMarkingsCount = styled.div`
  display: flex;
  line-height: 1;
  align-items: center;
  border-radius: 4px;
  background-color: rgba(42, 94, 246, 0.05);
  span {
    font-size: 12px;
    color: rgba(42, 94, 246, 1);
  }
`

export const IntegrationTabel = styled.div`
  display: flex;
  flex-direction: column;
  margin: 20px;
  border: 1px solid #f3f3f5;

  border-radius: 10px;
  > div {
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid #f3f3f5;
  }
  > div:last-child {
    border-bottom: none;
  }
`

export const IntegrationTabelCell = styled.div<{
  padding: string
  greyBackground?: boolean
}>`
  ${({ padding, greyBackground }) => css`
    display: flex;
    align-items: center;
    width: 50%;
    padding: ${padding};
    background-color: ${greyBackground ? 'rgba(42, 94, 246, 0.02)' : 'white'};
    border-left: ${greyBackground ? '1px solid #F3F3F5' : 'none'};
    line-height: 1;
    span {
      max-width: 100%;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    img {
      height: 26px;
      width: 26px;
      border-radius: 4px;
      border: 1px solid #fff;
      background-color: #fff;
    }
    img,
    svg {
      margin-right: 10px;
    }
  `}
`

export const IntegrationCountContainer = styled.div`
  display: flex;
  line-height: 1;
  align-items: center;
  border-radius: 4px;
  padding: 4px;
  background-color: rgba(42, 94, 246, 0.05);
  svg {
    margin-right: 2px;
  }
  span {
    color: rgba(42, 94, 246, 1);
  }
`
